import { Dispatch, SetStateAction } from 'react';

import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Modal from '@ui/modal/modal';
import Text from '@ui/text/text/text';
import OptionalComponent from '@ui/optional-component/optional-component';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import { EColorVariablesV2 } from '@/types/theme-packs.types';

type DeleteModalProps = {
  showDeleteModal: boolean;
  setShowDeleteModal: Dispatch<SetStateAction<boolean>>;
  onDelete?: () => void;
  img?: string | null;
};

const DeleteModal = ({ img, showDeleteModal, setShowDeleteModal, onDelete }: DeleteModalProps) => {
  return (
    <Modal
      size="large"
      open={showDeleteModal}
      onRequestClose={() => setShowDeleteModal(false)}
      RenderHeaderContent={() => (
        <Container height="70px" className="padding-t-24 padding-h-40">
          <Text tag="h4" className="H4">
            Delete Image
          </Text>
        </Container>
      )}
      RenderFooterContent={() => (
        <Container className="flex fd-row jc-flex-end ai-center padding-h-40 padding-v-24 gap-8">
          <Button
            onClick={() => {
              setShowDeleteModal(false);
            }}
            design="LocalBttnSec"
            height="53px"
          >
            Cancel
          </Button>
          <Button
            width="85px"
            height="53px"
            hoverOpacity={0.8}
            onClick={() => {
              setShowDeleteModal(false);
              onDelete?.();
            }}
            backgroundColor={getThemeColorCSSVariable()}
            className="flex ai-center"
          >
            <Text
              className="L2"
              color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
            >
              Delete
            </Text>
          </Button>
        </Container>
      )}
    >
      <Container className="flex fd-row jc-center ai-center">
        <OptionalComponent display={!!img}>
          <img src={img || ''} alt="delete" height={'100%'} width={'100%'} className="image-contain" />
        </OptionalComponent>
      </Container>
    </Modal>
  );
};

export default DeleteModal;
